import { render, staticRenderFns } from "./ItemsRelated.vue?vue&type=template&id=45785808&scoped=true&"
import script from "./ItemsRelated.vue?vue&type=script&lang=js&"
export * from "./ItemsRelated.vue?vue&type=script&lang=js&"
import style0 from "./ItemsRelated.vue?vue&type=style&index=0&id=45785808&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45785808",
  null
  
)

export default component.exports